export default __webpack_public_path__ + "static/media/DriveFactor-300w-min.00b03442.jpeg";